// extracted by mini-css-extract-plugin
module.exports = {"root":"SitesPage_root__3XG7n","headerContainer":"SitesPage_headerContainer__1sHPL","headerTitle":"SitesPage_headerTitle__1vVuq"};